module.exports = __webpack_public_path__ + "img/en.fe472b0b.png";